import { Directive } from '@angular/core';

@Directive( {
    selector: '[ridangoPrefix]'
    // tslint:disable-next-line:directive-selector
    // selector: 'ridango-prefix'

} )
export class PrefixDirective {

    constructor() { }

}
